import { FC } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { Color, Path, Svg } from "react-native-svg";

const Check: FC<{ style?: StyleProp<ViewStyle>; color?: Color }> = ({ style, color }) => (
  <Svg style={style} viewBox="0 0 11 9" fill="none">
    <Path
      d="M10.8389 0.621855C10.6241 0.407054 10.2759 0.407054 10.0611 0.621855L3.47176 7.21126L0.938921 4.67843C0.724142 4.46363 0.375923 4.46365 0.161101 4.67843C-0.0537002 4.89321 -0.0537002 5.24143 0.161101 5.45623L3.08285 8.37793C3.29756 8.59271 3.64604 8.59256 3.86067 8.37793L10.8389 1.39968C11.0537 1.1849 11.0537 0.836656 10.8389 0.621855Z"
      fill={color || "#000"}
    />
  </Svg>
);

export default Check;
